"use client";

import React, { useEffect, useRef, useState } from "react";
//import { FaPhone } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import Image from "next/image";

const phoneNumbers = [
  { id: 1, number: "+91-9513881313", city: "Ahmedabad" },
  { id: 2, number: "+91-9513881313", city: "Bangalore" },
  { id: 3, number: "+91-9513881313", city: "Chennai" },
  { id: 4, number: "+91-9513881313", city: "Delhi" },
  { id: 5, number: "+91-9513881313", city: "Hyderabad" },
  { id: 6, number: "+91-9513881313", city: "Ernakulam" },
  { id: 7, number: "+91-9513881313", city: "Kolkata" },
  { id: 8, number: "+91-9513881313", city: "Mumbai" },
  { id: 9, number: "+91-9513881313", city: "Pune" },
];

const CallNowButtonVisit = () => {
  const [isPhoneListOpen, setIsPhoneListOpen] = useState(false);
  const callNowDivRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        callNowDivRef.current &&
        !callNowDivRef.current.contains(event.target as Node)
      ) {
        setIsPhoneListOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="z-10 md:hidden block">
        {/* <button
          className="bg-[#1772ea] text-white flex py-[5px] px-[10px] rounded-[20px_20px_20px_0] items-center gap-2"
           onClick={() => setIsPhoneListOpen(!isPhoneListOpen)}
        >
          <FaPhone />
          <span className="font-medium">Call now</span>
        </button> */}
        <a
          href="tel:+919513881313"
          aria-label="Call us for more details"
          className="bg-[#3399FF] text-white rounded-[13px_13px_13px_0] flex items-center justify-center font-bold text-base gap-2 px-3 py-[3px] hover:brightness-95 transition-colors duration-200"
        >
          {/* Neither priority nor 40x40: this paints at 16px and is never the
              LCP, so it was fetching 6x the pixels and doing it ahead of the
              element that is. */}
          <Image
            src="https://ik.imagekit.io/mileseducation/miles_website/accounting/miles-education-cpa-fees-miles-education-cma/Call.webp"
            alt="Call icon"
            className="w-4 h-4"
            width={16}
            height={16}
          />
          <span className="flex flex-col items-start leading-[1]">
            <span className="text-[10px] font-normal">Talk to an Expert</span>
            <span className="text-[18px] font-bold">95138 81313</span>
          </span>
        </a>
      </div>
      {isPhoneListOpen && (
        <div ref={callNowDivRef} className="absolute top-[58px] right-4 z-[99]">
          <div className="bg-white shadow-2xl p-3 rounded-lg w-64">
            <div className="flex justify-between items-center">
              <p className="font-semibold pl-1">Click city to call:</p>
              <IoClose
                className="cursor-pointer w-6 h-6 text-black"
                onClick={() => setIsPhoneListOpen(false)}
              />
            </div>
            <ul>
              {phoneNumbers?.map((phone) => (
                <li key={phone.id} className="mt-2">
                  <a
                    href={`tel:${phone.number}`}
                    className="block px-4 py-2 bg-gray-100 rounded-md hover:bg-[#3174d6] hover:text-white text-black"
                  >
                    {phone.city}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default CallNowButtonVisit;
